export default __webpack_public_path__ + "77b67cb7dc27c4af324577586863ff0b.svg";